// broadcasting.js
import { opsViewDetailsUrl } from 'components/opsView/opsViewUtils';

// Get parent window ID from URL if we're in a popout window
const urlParams = new URLSearchParams(window.location.search);
const parentId = urlParams.get('parentId');

// Generate a unique ID for this window if it doesn't have one
if (!window.name) {
	window.name = `main-window-${Date.now()}`;
}

export const mainWindowId = 'main-window';
export const popoutWindowId = 'popout-window';

export const thisWindowId = window.location.pathname.includes(opsViewDetailsUrl)
	? `popout-window-${parentId}`
	: window.name;

// Create a unique channel name for this window pair
export const getChannelName = () => {
	if (window.location.pathname.includes(opsViewDetailsUrl)) {
		return `aircontrol-${parentId}`;
	}
	return `aircontrol-${window.name}`;
};

// Get the channel for this window pair
export const getChannel = () => {
	return new BroadcastChannel(getChannelName());
};
